import { useAppSelector } from "./store";

import "./InGamePlayerList.css";
import InGamePlayer from "./InGamePlayer";

function InGamePlayerList() {
  const players = useAppSelector((state) => {
    return state.players;
  });
  const profile = useAppSelector((state) => {
    return state.profile;
  });
  const gameData = useAppSelector((state) => {
    return state.game;
  });
  const renderedPlayers = players.map((player, index) => {
    return (
      <InGamePlayer
        key={player.id}
        currentTurn={index === gameData.currentPlayerIndex}
        playerInfo={player}
        profile={profile}
      />
    );
  });

  return (
    <table className="inGamePlayerList">
      <tbody className="inGamePlayerList">{renderedPlayers}</tbody>
    </table>
  );
}

export default InGamePlayerList;
